import React from "react";
import { Link } from "react-router-dom";

import { convertIntToMoney } from "../../helpers/conversions";

const Content = ({ item }) => (
    <>
        <div className="linked-item-top">
            <span className="linked-item-title">{item.title}</span>
            {item.value != null && (
                <span className="linked-item-value">{convertIntToMoney(item.value, true)}</span>
            )}
        </div>
        <div className="linked-item-meta">
            {item.status_label && (
                <span className={`linked-chip ${item.status_tone ?? 'neutral'}`}>{item.status_label}</span>
            )}
            {item.meta && <span>{item.meta}</span>}
        </div>
    </>
);

/**
 * Arquivo (nota ou boleto anexado) abre direto; registro navega para a tela
 * do módulo, ou abre ali mesmo quando `to` é uma função.
 */
export const Item = ({ item, to }) => {
    if (item.file_url) {
        return (
            <a className="linked-item" href={item.file_url} target="_blank" rel="noreferrer">
                <Content item={item} />
            </a>
        );
    }

    if (typeof to === 'function') {
        return (
            <button type="button" className="linked-item" onClick={to}>
                <Content item={item} />
            </button>
        );
    }

    if (!to) {
        return (
            <div className="linked-item is-static">
                <Content item={item} />
            </div>
        );
    }

    return (
        <Link className="linked-item" to={to}>
            <Content item={item} />
        </Link>
    );
}

export default Item;
